import { Alert } from 'rsuite';
import config from '../config';
import { CAMPAIGN_TYPE } from '../constants';
import { getWhiteLabelBrandByDomain } from '../constants/white-label-brands';
import { copyToClipboard } from '../utils/copyToClipboard';

export function createCampaignCustomDomain(domain) {
  const { protocol, host } = window.location;

  const isProduction = /^app\..*/i.test(host);

  if (isProduction) {
    return `${protocol}//${domain}.videopeel.com`;
  }

  return `${protocol}//${domain}.${host}`;
}

export function createBaseAppDomain() {
  const { host } = window.location;

  const isProduction = /^app\..*/i.test(host);

  if (isProduction) {
    return `videopeel.com`;
  }

  return host;
}

export function isValidCampaign(campaign) {
  const hasMinCampaignQuestions = campaign.campaignQuestions.length > 0;

  const isValidVideoCampaign =
    campaign.campaignTemplateType === CAMPAIGN_TYPE.VIDEO.value && campaign.videoCampaign;
  const isValidImageCampaign =
    campaign.campaignTemplateType === CAMPAIGN_TYPE.IMAGE.value && campaign.imageCampaign;
  const isValidProfileCampaign = campaign.campaignTemplateType === CAMPAIGN_TYPE.PERSONALIZED.value;

  return (
    campaign.campaignTemplateType === CAMPAIGN_TYPE.NEXT_GEN.value ||
    (hasMinCampaignQuestions &&
      (isValidVideoCampaign || isValidImageCampaign || isValidProfileCampaign))
  );
}

export const mountFinalCampaignLandingPageLink = (campaign) => {
  const {
    campaignLink,
    campaign_domain,
    campaignTemplateType,
    organizationCustomDomain,
  } = campaign;

  const campaignLinkWithPrefix = campaignTemplateType === 3 ? `c/${campaignLink}` : campaignLink;
  const whiteLabelBrand = getWhiteLabelBrandByDomain(organizationCustomDomain);

  const campaignLandingPageFinalLink = whiteLabelBrand
    ? `https://${organizationCustomDomain}/${campaignLinkWithPrefix}`
    : campaign_domain?.domain
    ? `${createCampaignCustomDomain(campaign_domain.domain)}/${campaignLinkWithPrefix}`
    : `${window.location.origin}/${campaignLinkWithPrefix}`;

  return campaignLandingPageFinalLink;
};

export const handleCopyCampaignLink = async (e, campaignLink, useAlert = true) => {
  e.stopPropagation();
  e.preventDefault();
  await copyToClipboard(campaignLink);

  useAlert && Alert.info('Copied Link to Clipboard');
};

export const createAndDownloadDataFromAnchorTag = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const duplicateCampaignHandler = async ({
  campaignId,
  campaignTitle,
  isNextGenCampaign,
  campaignNamesAsSet,
  _duplicateCampaign,
  _addCampaign,
  addSnackbarError,
  onChange
}) => {
  if (isNextGenCampaign) {
    await _duplicateCampaign({ sourceCampaignId: campaignId });
  } else {
    if (campaignNamesAsSet.includes(`${campaignTitle} - COPY`)) {
      addSnackbarError({ title: 'The duplicate campaign name has already been used' });
      return;
    }
    try {
      await _addCampaign({ campaignId: campaignId, name: `${campaignTitle} - COPY` });
    } catch (error) {
      addSnackbarError({ title: 'Failed to duplicate campaign' });
    }
  }
  onChange && onChange();
};

export const handleDownloadQR = (id) => {
  const canvas = document.getElementById(`QR-${id}`);
  const link = document.createElement('a');
  link.download = 'qrcode.png';
  link.href = canvas.toDataURL();
  link.click();
  link.remove();
};
export const calculatePrefix = (campaignTemplateType) => {
  // next gen campaigns are located at /c/<campaignLink>
  return campaignTemplateType === 3 ? 'c/' : '';
};

export const getAssetPath = (path) => {
  const SiteAssets = config.AWS.SiteAssets;
  const PATH = path.replace('optimized', 'original');

  return SiteAssets + '/' + PATH;
};



// WEBPACK FOOTER //
// ./src/helpers/campaignHelper.js